module.exports = __webpack_public_path__ + "static/media/instagram.bdad5b9c.png";